import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    creditUtilisationLimitTooltip: {
        id: '_.dashboard.approved.credit_utilisation_limit.tooltip',
        defaultMessage: `Every decision we make is valid for around 30 working days before it needs refreshing.`
    }
});
